import React from 'react';
import NavigationActionCreator from 'action_creators/navigation';
import AdditionalInformation from 'views/plugins/checkout/additional_information';
import { injectIntl } from 'react-intl';
import { triggerCheckoutStepScroll } from 'views/plugins/checkout/utils/scroll_utils';
import CheckoutHeader from '../header';
import Cover from '../cover';
import Submit from '../submit';
import { trackCheckoutMobileArriveOnPage } from '../segmentTracking';

class AdditionalInformationScreen extends React.Component {
  static displayName = 'AdditionalInformationScreen';

  componentDidMount() {
    triggerCheckoutStepScroll();
    const {
      flags,
      booking_request_id: bookingRequestId,
      fields,
      tour_id: tourId,
      tour,
    } = this.props;

    trackCheckoutMobileArriveOnPage({
      flags,
      bookingRequestId: bookingRequestId || fields?.get('id'),
      tourId,
      guideId: tour?.guide_id,
      guideName: tour?.guide_name,
      pageName: 'Checkout Additional Information',
    });
  }

  componentDidUpdate(prevProps) {
    if (this._hasSaved(prevProps)) {
      NavigationActionCreator.transitionTo(
        'Views.Plugins.Checkout.Mobile.Screens.CheckoutSummary'
      );
    }
  }

  _hasSaved(prevProps) {
    return this.props.saved === true && prevProps.saved === false;
  }

  _googleTagManagerCheckoutProgress = (step) => {
    const {
      total,
      tour_id,
      guests,
      is_ga4_enabled,
      currency,
      unitPriceForInitialPricing,
      totalWithoutServiceFee,
      units_and_addons_detail,
    } = this.props;
    const { name } = this.props.tour;
    try {
      googleTagManagerCheckout(
        {
          tour_id,
          guests,
          name,
          total_price: total,
          is_ga4_enabled,
          currency: currency.toUpperCase(),
          unit_price_for_initial_pricing: unitPriceForInitialPricing,
          total_without_service_fee: totalWithoutServiceFee,
          units_and_addons_detail: units_and_addons_detail.toJS(),
        },
        step
      );
    } catch (error) {
      console.log('google tag error', error);
    }
  };

  _additionalInformationProps() {
    return {
      fields: this.props.fields,
      errors: this.props.errors,
      showQuestions: this._shouldShowQuestions(),
      showWaiver: this._shouldShowWaiver(),
      waiverProps: this._waiverProps(),
      questionsProps: this._questionsProps(),
      isAffiliate: this.props.isAffiliate,
    };
  }

  _shouldShowWaiver() {
    return this.props.tour.tour_waiver_info.required;
  }

  _shouldShowQuestions() {
    const { questions } = this._questionsProps();
    return questions && !!questions.length;
  }

  _waiverProps() {
    return { ...this.props, ...this.props.tour.tour_waiver_info };
  }

  _questionsProps() {
    return {
      ...this.props,
      questions: this.props.questionsProps.questions,
      onChange: this.props.questionsProps.onChange,
      googleTagManagerCheckoutProgress: this._googleTagManagerCheckoutProgress,
    };
  }

  _coverProps() {
    return {
      forInvoice: this.props.forInvoice,
      tourPicture: this.props.tour.picture,
      guideAvatar: this.props.tour.guide_avatar,
      tourName: this.props.tour.name_translation,
      guideName: this.props.tour.guide_name,
      hasResource: this.props.has_resource,
      resourceName: this.props.resource_name,
    };
  }

  render() {
    const { timer, intl, priceProps, onSubmit } = this.props;
    return (
      <div className="AdditionalInformationScreen">
        <CheckoutHeader priceProps={priceProps} />
        <article className="transition-ctx">
          <Cover {...this._coverProps()} />
          {timer}
          <div className="BookingRequest-form ui form">
            <AdditionalInformation {...this._additionalInformationProps()} />
            <Submit
              dataTestProp="review-details"
              label={intl.formatMessage({
                id: 'NEXT_STEP_REVIEW_DETAILS',
                defaultMessage: 'Next: Review details',
              })}
              onSubmit={onSubmit.bind(this)}
            />
          </div>
        </article>
      </div>
    );
  }
}

export default injectIntl(AdditionalInformationScreen);
